export default __webpack_public_path__ + "a74394da4dd09d888d5ba7fb86de5115.svg";